import { BaseLogDocument } from './base-log-document';
import { LogDocumentType } from '../../enums';
import { BaseDoc } from '../base/base-doc';

export class LogWithoutIds extends BaseDoc {
    public _id: any;
    public affectedUser: string;
    public context: BaseLogDocument;
    public type: LogDocumentType;

    constructor(params?: Partial<LogWithoutIds>) {
        super(params);
        if (params) {
            this._id = params._id || this._id;
            this.affectedUser = params.affectedUser || this.affectedUser;
            this.context = params.context || this.context;
            this.type = params.type || this.type;
        }
    }
}
